
import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addPaymentType, deletePaymentType, getAllPaymentType, updatePaymentType } from '../../redux/rtk/features/masters/paymentTypeSlice';
import PageTitle from '../page-header/PageHeader';

const PaymentTypeMaster = () => {
  const { Title } = Typography;
  const [editingpaymentType, setEditingpaymentType] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.paymentType);

  useEffect(() => {
    dispatch(getAllPaymentType());
  }, [dispatch]);


  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingpaymentType) {
        // Update existing paymentType
        const result = await dispatch(
          updatePaymentType({ id: editingpaymentType.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllPaymentType());
        } else {
          message.error('Error updating paymentType!');
        }
      } else {
        // Add new paymentType
        const result = await dispatch(addPaymentType(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllPaymentType());
        } else {
          message.error('Error adding paymentType!');
        }
      }
      setEditingpaymentType(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      // message.error('Failed to add or update paymentType!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deletePaymentType(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllPaymentType()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Payment Type',
      dataIndex: 'paymentType',
      key: 'paymentType',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => { setEditingpaymentType(record); form.setFieldsValue(record) }}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this payment type?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingpaymentType ? 'Edit Payment Type' : 'Add Payment Type'}>

            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="payment-Type-form"
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
              <Form.Item
                name="paymentType"
                label="Payment Type"
                rules={[{ required: true, message: 'Please enter a payment Type!' }]}
              >
                <Input placeholder="Enter payment Type " />
              </Form.Item>

              <Button type="primary" block htmlType="submit">
                {editingpaymentType ? 'Update Payment Type' : 'Add Payment Type'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Payment Type List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PaymentTypeMaster;

